module.exports = __webpack_public_path__ + "img/helicopter_b.5b1073ea.svg";